import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../reactive/AppState.js.mjs';
import {
  setupResizeListener3vth0wdbpatzm as setupResizeListener,
  onDelegateSet690ei966ebv5 as onDelegateSet,
} from './Canvas.commonHtml.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CanvasClass;
function Canvas() {
  if (CanvasClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.abi_1 = null;
        this.vb5_1.zb3_1 = 'canvas';
        // Inline function 'com.lightningkite.kiteui.views.tabIndex' call
        this.vb5_1.bb4_1.kb7_1.tabIndex = 1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dbi(it.code)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'keydown'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'keydown';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.dbi(it.code)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_1 = this.vb5_1;
        var tmp0_safe_receiver_0 = this_1.xb3_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ebi(it.code)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = this_1.gb4_1['on' + 'keyup'];
          var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + 'keyup';
          this_1.gb4_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ebi(it.code)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_2 = this.vb5_1;
        var tmp0_safe_receiver_1 = this_2.xb3_1;
        var tmp_5;
        if (tmp0_safe_receiver_1 == null) {
          tmp_5 = null;
        } else {
          tmp0_safe_receiver_1.addEventListener('wheel', (it) => {
            if (!(it instanceof WheelEvent))
              THROW_CCE();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fbi(it.deltaX, it.deltaY, it.deltaZ)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_5 = Unit_instance;
        }
        if (tmp_5 == null) {
          // Inline function 'kotlin.run' call
          var tmp_6 = this_2.gb4_1['on' + 'wheel'];
          var old_1 = (!(tmp_6 == null) ? typeof tmp_6 === 'function' : false) ? tmp_6 : null;
          var tmp_7 = 'on' + 'wheel';
          this_2.gb4_1[tmp_7] = (it) => {
            var tmp0_safe_receiver = old_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof WheelEvent))
              THROW_CCE();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fbi(it.deltaX, it.deltaY, it.deltaZ)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        var tmp0 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name = 'pointerdown';
        var tmp0_safe_receiver_2 = tmp0.xb3_1;
        var tmp_8;
        if (tmp0_safe_receiver_2 == null) {
          tmp_8 = null;
        } else {
          tmp0_safe_receiver_2.addEventListener(name, (it) => {
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_8 = Unit_instance;
        }
        if (tmp_8 == null) {
          // Inline function 'kotlin.run' call
          var tmp_9 = tmp0.gb4_1['on' + name];
          var old_2 = (!(tmp_9 == null) ? typeof tmp_9 === 'function' : false) ? tmp_9 : null;
          var tmp_10 = 'on' + name;
          tmp0.gb4_1[tmp_10] = (it) => {
            var tmp0_safe_receiver = old_2;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.pbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        var tmp0_0 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_0 = 'pointermove';
        var tmp0_safe_receiver_3 = tmp0_0.xb3_1;
        var tmp_11;
        if (tmp0_safe_receiver_3 == null) {
          tmp_11 = null;
        } else {
          tmp0_safe_receiver_3.addEventListener(name_0, (it) => {
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_11 = Unit_instance;
        }
        if (tmp_11 == null) {
          // Inline function 'kotlin.run' call
          var tmp_12 = tmp0_0.gb4_1['on' + name_0];
          var old_3 = (!(tmp_12 == null) ? typeof tmp_12 === 'function' : false) ? tmp_12 : null;
          var tmp_13 = 'on' + name_0;
          tmp0_0.gb4_1[tmp_13] = (it) => {
            var tmp0_safe_receiver = old_3;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        var tmp0_1 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_1 = 'pointerup';
        var tmp0_safe_receiver_4 = tmp0_1.xb3_1;
        var tmp_14;
        if (tmp0_safe_receiver_4 == null) {
          tmp_14 = null;
        } else {
          tmp0_safe_receiver_4.addEventListener(name_1, (it) => {
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_14 = Unit_instance;
        }
        if (tmp_14 == null) {
          // Inline function 'kotlin.run' call
          var tmp_15 = tmp0_1.gb4_1['on' + name_1];
          var old_4 = (!(tmp_15 == null) ? typeof tmp_15 === 'function' : false) ? tmp_15 : null;
          var tmp_16 = 'on' + name_1;
          tmp0_1.gb4_1[tmp_16] = (it) => {
            var tmp0_safe_receiver = old_4;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.rbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        var tmp0_2 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_2 = 'pointercancel';
        var tmp0_safe_receiver_5 = tmp0_2.xb3_1;
        var tmp_17;
        if (tmp0_safe_receiver_5 == null) {
          tmp_17 = null;
        } else {
          tmp0_safe_receiver_5.addEventListener(name_2, (it) => {
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_17 = Unit_instance;
        }
        if (tmp_17 == null) {
          // Inline function 'kotlin.run' call
          var tmp_18 = tmp0_2.gb4_1['on' + name_2];
          var old_5 = (!(tmp_18 == null) ? typeof tmp_18 === 'function' : false) ? tmp_18 : null;
          var tmp_19 = 'on' + name_2;
          tmp0_2.gb4_1[tmp_19] = (it) => {
            var tmp0_safe_receiver = old_5;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.sbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        var tmp0_3 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_3 = 'pointerleave';
        var tmp0_safe_receiver_6 = tmp0_3.xb3_1;
        var tmp_20;
        if (tmp0_safe_receiver_6 == null) {
          tmp_20 = null;
        } else {
          tmp0_safe_receiver_6.addEventListener(name_3, (it) => {
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver = this.abi_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_20 = Unit_instance;
        }
        if (tmp_20 == null) {
          // Inline function 'kotlin.run' call
          var tmp_21 = tmp0_3.gb4_1['on' + name_3];
          var old_6 = (!(tmp_21 == null) ? typeof tmp_21 === 'function' : false) ? tmp_21 : null;
          var tmp_22 = 'on' + name_3;
          tmp0_3.gb4_1[tmp_22] = (it) => {
            var tmp0_safe_receiver = old_6;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            var dpr = AppState_getInstance().obi().f2().ibi_1;
            if (!(it instanceof PointerEvent))
              THROW_CCE();
            var tmp = it.target;
            var b = (tmp instanceof Element ? tmp : THROW_CCE()).getBoundingClientRect();
            var tmp0_safe_receiver_0 = this.abi_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.sbi(it.pointerId, (it.pageX - b.x) * dpr, (it.pageY - b.y) * dpr, b.width * dpr, b.height * dpr)) === true) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        setupResizeListener(this);
      }
      tbi(value) {
        this.abi_1 = value;
        onDelegateSet(this, value);
        if (value == null)
          null;
        else {
          value.cbi_1 = this.rb6_1.gb1_1;
        }
        var tmp1_safe_receiver = this.abi_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bbi_1;
        if (tmp2_safe_receiver == null)
          null;
        else
          tmp2_safe_receiver();
      }
      ub9(theme) {
        super.ub9(theme);
        var tmp0_safe_receiver = this.abi_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cbi_1 = theme.gb1_1;
        }
        var tmp1_safe_receiver = this.abi_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bbi_1;
        if (tmp2_safe_receiver == null)
          null;
        else
          tmp2_safe_receiver();
      }
    }
    initMetadataForClass($, 'Canvas');
    CanvasClass = $;
  }
  return CanvasClass;
}
//region block: exports
export {
  Canvas as Canvas2ofr7h6unhudb,
};
//endregion

//# sourceMappingURL=Canvas.commonHtml.mjs.map
